import React, { useEffect, useState } from "react";

import { connect } from "react-redux";
import passwordValidator from "password-validator";
import { Actions as CREATEACCOUNTACTIONS } from "../../store/actions/createAccountActions";
import { Actions as LOGINACTIONS } from "../../store/actions/authenticationActions";
import * as yup from "yup";
import { ExclamationCircleIcon } from "@heroicons/react/20/solid";
import { appUrl } from "../../utils/appHandoff";

// Create a schema
var schema = new passwordValidator();

// Add properties to it
schema
	.is()
	.min(8) // Minimum length 8
	.is()
	.max(100) // Maximum length 100
	.has()
	.uppercase() // Must have uppercase letters
	.has()
	.lowercase() // Must have lowercase letters
	.has()
	.digits(1) // Must have at least 1 digits
	.has()
	.not()
	.spaces(); // Should not have spaces
// .is().not().oneOf(['Passw0rd', 'Password123']); // Blacklist these values

let emailSchema = yup.object().shape({
	email: yup.string().required().email(),
});

function RegistrationForm({
	createAccount,
	updateUserDetails,
	jurisdiction,

	error,
	creatingAccount,
	userCreated,
	userUpdated,
	acLeadCreated,
	demoAccountCreated,
	joinOrder,
	hideFooter,
	formFooter,
}) {
	useEffect(() => {
		// load initial data required for anywhere
		if (!creatingAccount && userCreated && userUpdated && acLeadCreated && demoAccountCreated) {
			// redirect to app dashboard
			window.location.href = appUrl();
		}
	}, [creatingAccount]);

	const [errorText, setErrorText] = useState("");
	const [isEmailValid, setIsEmailValid] = useState(true);

	const isJoint = !isNaN(joinOrder);

	const [data, setData] = useState({
		name: "",
		surname: "",
		email: "",
		password: "",
		jurisdiction: jurisdiction ?? "MT",
	});

	const handleChange = (event) => {
		setData({
			...data,
			[event.target.name]: event.target.value,
		});
	};

	const createDemoAccountSubmit = (e) => {
		emailSchema
			.isValid({
				email: data.email,
			})
			.then(function (valid) {
				e.preventDefault();
				if (valid) {
					console.log("dataToSubmit", data);
					createAccount(data);
				} else {
					setErrorText("Invalid email format");
					setIsEmailValid(false);
				}
			});
	};

	return (
		<div
			className={`${
				isJoint ? `ml-${joinOrder % 2 ? "0" : "auto"} mr-${joinOrder % 2 ? "auto" : "0"}` : "sm:mx-auto"
			} bg-white sm:max-w-md sm:w-full sm:overflow-hidden ${
				isJoint
					? joinOrder % 2
						? "rounded-r-md sm:rounded-r-lg"
						: "rounded-l-md sm:rounded-l-lg"
					: "rounded-md sm:rounded-lg"
			} ${isJoint ? "" : "border border-gray-200"}`}
		>
			<div className="flex">
				{(isJoint && joinOrder % 2) ? <div className="separator" /> : null}
				<div className="block">
					<div className="px-4 py-8 sm:px-10">
						<div className="mt-6">
							{error && (
								<div className="rounded-md bg-red-50 p-4 mb-6">
									<div className="flex">
										<div className="ml-3">
											<h3 className="text-sm leading-5 font-medium text-red-800">
												Error: {error}
											</h3>
										</div>
									</div>
								</div>
							)}

							<form
								onSubmit={createDemoAccountSubmit}
								className="space-y-6"
							>
								<div>
									<label
										htmlFor="name"
										className="sr-only"
									>
										Name
									</label>
									<div className="rounded-md shadow-sm">
										<input
											value={data.name}
											onChange={handleChange}
											name="name"
											id="name"
											placeholder="Name"
											required
											className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
										/>
									</div>
								</div>

								<div>
									<label
										htmlFor="surname"
										className="sr-only"
									>
										Surname
									</label>
									<div className="rounded-md shadow-sm">
										<input
											value={data.surname}
											onChange={handleChange}
											name="surname"
											id="surname"
											placeholder="Surname"
											required
											className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
										/>
									</div>
								</div>

								<div>
									<label
										htmlFor="email"
										className="sr-only"
									>
										Email
									</label>
									<div className="relative rounded-md shadow-sm">
										<input
											value={data.email}
											onChange={handleChange}
											name="email"
											id="email"
											placeholder="Email"
											required
											className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
											aria-invalid="true"
											aria-describedby="email-error"
										/>
										{!isEmailValid && (
											<div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
												<ExclamationCircleIcon
													className="h-5 w-5 text-red-500"
													aria-hidden="true"
												/>
											</div>
										)}
									</div>
									<p
										className="mt-2 text-sm text-red-600"
										id="email-error"
									>
										{errorText}
									</p>
								</div>
								<div>
									<label
										htmlFor="password"
										className="sr-only"
									>
										Password
									</label>
									<div className="rounded-md shadow-sm">
										<input
											value={data.password}
											onChange={handleChange}
											autoComplete="off"
											name="password"
											id="password"
											type="password"
											placeholder="Password"
											required
											className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
										/>
									</div>
								</div>
								<div>
									<span className="block w-full rounded-md shadow-sm">
										<button
											type="submit"
											className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-orange-600 hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange active:bg-orange-700 transition duration-150 ease-in-out"
										>
											Register with Buddy
										</button>
									</span>
								</div>
							</form>
						</div>
					</div>
					<div
						className={`px-4 ${
							hideFooter ? "pb-5" : "py-6 bg-gray-50 border-t-2 border-gray-200"
						} sm:px-10`}
					>
						<p className="text-xs leading-5 text-gray-500">
							By signing up, you agree to our{" "}
							<a
								target="_blank"
								href="/terms"
								className="font-medium text-gray-900 hover:underline"
							>
								Terms
							</a>
							,{" "}
							<a
								target="_blank"
								href="/terms"
								className="font-medium text-gray-900 hover:underline"
							>
								Data Policy
							</a>{" "}
							and{" "}
							<a
								target="_blank"
								href="/terms"
								className="font-medium text-gray-900 hover:underline"
							>
								Cookies Policy
							</a>
							.
						</p>
					</div>
				</div>
				{(isJoint && joinOrder % 2 == 0) ? <div className="separator" /> : null}
			</div>
			{formFooter}
		</div>
	);
}

const mapStateToProps = (state) => {
	const createAccount = state && state.createAccount;
	const profile = state && state.my && state.my.profile;

	return {
		creatingAccount: createAccount.creating,
		error: createAccount.error,
		userCreated: createAccount.userCreated,
		userUpdated: createAccount.userUpdated,
		acLeadCreated: createAccount.acLeadCreated,
		demoAccountCreated: createAccount.demoAccountCreated,
		profile,
		processing: state.authentication.processing,
	};
};

const mapDispatchToProps = (dispatch) => ({
	createAccount: (data) => dispatch(CREATEACCOUNTACTIONS.createAccount(data)),
	updateUserDetails: (data) => dispatch(CREATEACCOUNTACTIONS.updateUserDetails(data)),
	logout: () => dispatch(LOGINACTIONS.logout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(RegistrationForm);
